type ConvertToFileProps = {
  base64: string;
  fileName: string;
  mimeType: string;
};
export default async function base64ToFile({
  base64,
  fileName,
  mimeType,
}: ConvertToFileProps): Promise<File> {
  const response = await fetch(base64);
  const processedArrayBuffer = await response.arrayBuffer();
  return new File([processedArrayBuffer], fileName, { type: mimeType });
}
